import Markdown from "markdown-to-jsx";
import { useState, useRef, useEffect } from "react";
import { setReceiverLoader } from "../features/chatbot/store/ChatBotStore.ts";
import { store } from "../store/GlobalStore.ts";
import { ChatBotHelper } from "../features/chatbot/handlers/ChatBotHelper.ts";

let TAG = "[TypingMessage]."
const TypingMessage: React.FC<{
    text: string;
    className: string;
    scrollRef: React.RefObject<HTMLDivElement>,
    messageIndex: number;
    setAnimatedIndex: (i: number) => void;
    isScrollingUpRef: any
    isWordEffect: boolean

}> = ({ text, className, scrollRef, messageIndex, setAnimatedIndex, isScrollingUpRef, isWordEffect }) => {

    const [displayedWords, setDisplayedWords] = useState<string[]>([]);
    const [displayedChar, setDisplayedChar] = useState<string>("");
    const indexRef = useRef(0);
    //store.dispatch(setReceiverLoader(false));

    useEffect(() => {
        store.dispatch(setReceiverLoader(false));
    }, []);

    useEffect(() => {
        try {

            if (!text) return;

            console.log(TAG + "TypingMessage() ========= ");

            let interval: any = null;
            indexRef.current = 0;

            if (isWordEffect) {

                const words = text.split(" ");
                setDisplayedWords([]);
                interval = performWordTypingEffect(words);
            } else {

                setDisplayedChar('');
                interval = performCharacterTypingEffect(text);
            }

            return () => clearInterval(interval);

        } catch (e) {

            console.log(TAG + "TypingMessage() Error :: " + e);
        }

    }, [text, scrollRef]);


    const performWordTypingEffect = (words: string[]) => {
        try {

            const interval = setInterval(() => {

                if (indexRef.current < words.length) {

                    const word = words[indexRef.current];

                    setDisplayedWords(prev => {

                        const updated = [...prev, word];

                        if (!isScrollingUpRef.current && scrollRef.current) {
                            scrollRef.current.scrollIntoView({ behavior: "auto" });
                        }

                        return updated;
                    });

                    indexRef.current++;
                } else {

                    clearInterval(interval);
                    setAnimatedIndex(messageIndex);
                }

            }, 50); // Typing speed in ms

            return interval;

        } catch (e) {
            console.log(TAG + "performWordTypingEffect() Error :: " + e);
        }
    }

    const performCharacterTypingEffect = (text: string) => {
        try {

            const interval = setInterval(() => {

                if (indexRef.current < text.length) {

                    const nextChar = text.charAt(indexRef.current);
                    setDisplayedChar(prev => {

                        if (!isScrollingUpRef.current && scrollRef.current) {
                            scrollRef.current.scrollIntoView({ behavior: "auto" });
                        }

                        return prev + nextChar;
                    });

                    indexRef.current += 1;

                } else {

                    clearInterval(interval);
                    setAnimatedIndex(messageIndex);
                }

            }, 20); // Typing speed in ms

            return interval;

        } catch (e) {
            console.log(TAG + "performCharacterTypingEffect() Error :: " + e);
        }
    }

    return (
        <Markdown className={className}
            options={{
                overrides: {
                    a: {
                        props: {
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }
                    }
                }
            }}>

            {/* The below line is if word effect is enabled then word by word typing , else character by character typing */}
            {isWordEffect ?
                ChatBotHelper.getInstance().autoLinkifyMarkdown(displayedWords.join(" ")) :
                ChatBotHelper.getInstance().autoLinkifyMarkdown(displayedChar)
            }
        </Markdown>
    );
};

export default TypingMessage;